import { Box } from '@mui/material';
import { Toolbar, ToolbarPropsOverrides } from '@mui/x-data-grid';

declare module '@mui/x-data-grid' {
    interface ToolbarPropsOverrides {
        additionalTool?: {
            left?: React.ReactNode;
            right?: React.ReactNode;
        };
    }
}
export function HomeworkManagerTableToolbar(props: ToolbarPropsOverrides) {
    return (
        <Toolbar>
            {props.additionalTool?.left}
            <Box sx={{ flexGrow: 1 }} />
            {props.additionalTool?.right}
        </Toolbar>
    );
}
